export default "__VITE_ASSET__CFtYz$GR__"